import range from '../../../../utils/range';

export const orderStatuses = {
    DELIVERY: {
        status: 'В доставке',
        color: 'blue',
        value: [...range(2031, 2080)],
    },
    CANCELED_BY_SELLER: {
        status: 'Отменён продавцом',
        color: 'grey',
        value: [2140, 2145],
    },
    IN_PROCESS: {
        status: 'В обработке',
        color: 'grey',
        value: range(2000, 2300),
    },
    AWAITS_RECEIVING: {
        status: 'Ожидает получения',
        color: 'green',
        value: [2200], 
    },
};

export const validStatuses = range(2000, 2300);